import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./assets/logo.png"; // عدّل المسار حسب مشروعك

const format = (v) => (v == null ? "" : String(v));

function generateDeliveryOrderPdf({ header, bol }) {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  // ===== 1) اللوقو =====
  const logoW = 50;
  const logoH = 15;
  const logoX = 20;
  const logoY = 10;
  doc.addImage(logo, "PNG", logoX, logoY, logoW, logoH);

  // ===== 2) عنوان المستند =====
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("DELIVERY ORDER", pageWidth / 2, 30, { align: "center" });

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(`DO NO: ${bol.bol_id}`, pageWidth - 40, 30);

  // ===== 3) PLEASE DELIVER TO =====
  let y = 40;
  doc.setFont("helvetica", "bold");
  doc.text("PLEASE DELIVER TO:", 20, y);
  y += 4;
  doc.setLineWidth(0.2);
  doc.line(20, y, pageWidth - 20, y); // خط طويل تحت PLEASE DELIVER TO

  // ===== 4) الجدول الرئيسي =====
  y += 6;

  const tableX = 20;
  const tableWidth = pageWidth - 40;

  // مستطيل كامل
  const tableTop = y;
  const row1H = 30; 
  const rowHeaderH = 8; 
  const rowDetailsH = 24; 
  const totalHeight = row1H + rowHeaderH + rowDetailsH;
  doc.rect(tableX, tableTop, tableWidth, totalHeight);

  // تقسيم صف 1 (يسار/يمين)
  const midX = tableX + tableWidth * 0.5; 
  doc.line(midX, tableTop, midX, tableTop + row1H);

  // خطوط داخل الجزء الأيمن لصف 1
  const rightColX = midX;
  const colRightWidth = tableWidth - (midX - tableX);
  const row1Line1Y = tableTop + 6;
  const row1Line2Y = tableTop + 12;
  const row1Line3Y = tableTop + 18;
  const row1Line4Y = tableTop + 24;
  doc.line(rightColX, row1Line1Y, rightColX + colRightWidth, row1Line1Y);
  doc.line(rightColX, row1Line2Y, rightColX + colRightWidth, row1Line2Y);
  doc.line(rightColX, row1Line3Y, rightColX + colRightWidth, row1Line3Y);
  doc.line(rightColX, row1Line4Y, rightColX + colRightWidth, row1Line4Y);

  // نصوص صف 1
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  const consigneeName = format(bol.consignee_name || "");
  const consigneeMaxWidth = midX - tableX - 6; // 6 for padding
  const consigneeLines = doc.splitTextToSize(consigneeName, consigneeMaxWidth);
  doc.text(consigneeLines, tableX + 3, tableTop + 8);

  doc.text("Flight No.", rightColX + 3, tableTop + 4.5);
  doc.text("Arrival Date:", rightColX + 3, row1Line1Y + 4);
  doc.text("Arrival from:", rightColX + 3, row1Line2Y + 4);
  doc.text("Manifest No.", rightColX + 3, row1Line3Y + 4);
  doc.text("Registration:", rightColX + 3, row1Line4Y + 4);

  doc.setFont("helvetica", "normal");
  const valueOffset = rightColX + 30; 
  doc.text(format(header.voyage_number || ""), valueOffset, tableTop + 4.5);
  doc.text(format(header.date_of_arrival || ""), valueOffset, row1Line1Y + 4);
  doc.text(format(header.place_of_departure_code || ""), valueOffset, row1Line2Y + 4);
  doc.text(format(header.manifest_no ?? header.id ?? ""), valueOffset, row1Line3Y + 4);
  doc.text(format(header.registration || ""), valueOffset, row1Line4Y + 4);

  // ===== صف الهيدر (MAWB Header) =====
  const headerY = tableTop + row1H;
  doc.line(tableX, headerY, tableX + tableWidth, headerY);

  const col1W = tableWidth * 0.25;
  const col2W = tableWidth * 0.2;
  const col3W = tableWidth * 0.35;
  const col4W = tableWidth * 0.2;

  const c1X = tableX;
  const c2X = c1X + col1W;
  const c3X = c2X + col2W;
  const c4X = c3X + col3W;

  // الخطوط الرأسية
  doc.line(c2X, headerY, c2X, headerY + rowHeaderH + rowDetailsH); 
  doc.line(c3X, headerY, c3X, headerY + rowHeaderH + rowDetailsH);
  doc.line(c4X, headerY, c4X, headerY + rowHeaderH + rowDetailsH);

  const headerTextY = headerY + 5;
  doc.setFont("helvetica", "bold");
  doc.text("MAWB", c1X + 3, headerTextY); 
  doc.text("No. of Pieces", c2X + 3, headerTextY);
  doc.text("Nature of Goods", c3X + 3, headerTextY);
  doc.text("Weight", c4X + 3, headerTextY);

  // ===== صف البيانات (MAWB + HAWB) =====
  const detailsY = headerY + rowHeaderH;
  doc.line(tableX, detailsY, tableX + tableWidth, detailsY);

  const pieces = bol.number_of_packages ?? "";
  const weight = bol.gross_mass ?? "";
  const mawb = bol.mawb_no || bol.bol_reference || "";
  const hawb = bol.hawb_no || "";

  // تقسيم العمود الأول لـ 3 أجزاء بدلاً من 4 لحذف المستطيل الفارغ
  const subRowH = rowDetailsH / 3; 
  const line1Y = detailsY + subRowH;
  const line2Y = detailsY + subRowH * 2;

  // الخطوط القصيرة في العمود الأول فقط
  doc.line(tableX, line1Y, c2X, line1Y);
  doc.line(tableX, line2Y, c2X, line2Y);

  // نصوص العمود الأول
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(format(mawb), c1X + 3, line1Y - 3); // رقم MAWB

  doc.setFont("helvetica", "bold");
  doc.text("HAWB NO.", c1X + 3, line1Y + 5); // عنوان HAWB NO. (متصل مباشرة)

  doc.setFont("helvetica", "normal");
  doc.text(format(hawb), c1X + 3, line2Y + 5); // رقم HAWB

  // ---- بقية البيانات في صف التفاصيل ----
  const dataY = detailsY + rowDetailsH / 2 + 2;
  doc.setFontSize(10);
  doc.text(String(pieces), c2X + 3, dataY);
  doc.text(format(bol.goods_description || ""), c3X + 3, dataY);
  doc.text(String(weight), c4X + 3, dataY);

  // ===== 5) نص الاستلام، تاريخ، توقيع =====
  y = tableTop + totalHeight + 15;
  doc.setFont("helvetica", "normal");
  doc.text(
    "The documents enumerated above been received by .......................................................",
    20,
    y
  );

  y += 12;
  doc.text("Date: .................................", 20, y);
  doc.text("Signature: ............................................................", pageWidth / 2, y);

  // ===== حفظ الملف =====
  const fileName = `DeliveryOrder_${bol.bol_reference || bol.id}.pdf`;
  doc.save(fileName);
}

export default generateDeliveryOrderPdf;